export const PORT_SECURITY_URL = process.env.REACT_APP_PORT_SECURITY_URL;
export const NOC_SUPPORT_EMAIL = process.env.REACT_APP_NOC_SUPPORT_EMAIL;
export const FORGOT_PASSWORD_PATH = `/forgot_password`;
export const RESET_PASSWORD_PATH = `/reset_password`;
export const COMPLETE_REGISTRATION_PATH = `/complete_registration`;
export const NONE_SELECTED = 'None';
export const TAG_MIN_VALUE = 11;
export const TAG_MAX_VALUE = 4089;
export const DEFAULT_SEARCH_TERM = '';
export const DEFAULT_SEARCH_BY = 'xml_id';
export const OVERSUBSCRIPTION_MIN_VALUE = 0;
export const OVERSUBSCRIPTION_MAX_VALUE = 100;
export const EMAIL_LIST_DELIMITER = ',';
